import { i18n } from '../translate/i18n';

const getArraysDifference = (initialArr, newArr) => {
    const removed = initialArr.filter((initialData) => !newArr.some(newData => newData._id === initialData._id));
    const added = newArr.filter((newData) => !initialArr.some(initialData => initialData._id === newData._id));

    return {
        added: added,
        removed: removed
    };
}

const formatNamesOnArray = (array) => {
    if (array.length === 1) return array[0].name;
    const names = array?.map((acc) => acc.name);
    return names.slice(0, -1).join(', ') + ', ' + names.slice(-1);
}

export const borderColor = (props) => {
    switch(props.type) {
        case 'creation': {
            return 'green';
        }
        case 'changeStatus': {
            if(props.changeStatus.from) {
                return '#585858';
            } else {
                return 'green';
            }
        }
        case 'changeMaintenanceStatus': {
            if(props.changeMaintenanceStatus.to === false) {
                return 'darkblue';
            } else {
                return '#0363c3';
            }
        }
        case 'changeEquipmentModel': {
            return 'green';
        }
        case 'changeCompany': {
            return 'green';
        }
        case 'changeReference': {
            return 'green';
        }
        case 'changeSerialNumber': {
            return 'green';
        }
        case 'changePlace': {
            return 'green';
        }
        case 'changeBrand': {
            return 'green';
        }
        case 'changeCompanies': {
            return 'green';
        }
        default: {
            return 'green';
        }
    }
};

export const formatTitle = (props) => {
    switch(props.type) {
        case 'creation': {
            return `<b style="color: green">${i18n.t('formatTitle.creation')}</b>`;
        }
        case 'changeStatus': {
            if(props.changeStatus.from) {
                return `<b style="color: #585858;">${i18n.t('formatTitle.changeStatusTrue')}</b>`;
            } else {
                return `<b style="color: green;">${i18n.t('formatTitle.changeStatusFalse')}</b>`;
            }
        }
        case 'changeMaintenanceStatus': {
            if(props.changeMaintenanceStatus.to === false) {
                return `<b style="color: darkblue">${i18n.t('formatTitle.changeMaintenanceStatusTrue')}</b>`;
            } else {
                return `<b style="color: #0363c3">${i18n.t('formatTitle.changeMaintenanceStatusFalse')}</b>`;
            }
        }
        case 'changeEquipmentModel': {
            return `<b>${i18n.t('formatTitle.changeEquipmentModel')}</b>`;
        }
        case 'changeCompany': {
            return `<b>${i18n.t('formatTitle.changeCompany')}</b>`;
        }
        case 'changeReference': {
            return `<b>${i18n.t('formatTitle.changeReference')}</b>`;
        }
        case 'changeSerialNumber': {
            return `<b>${i18n.t('formatTitle.changeSerialNumber')}</b>`;
        }
        case 'changeDescription': {
          return `<b>${i18n.t('formatTitle.changeDescription')}</b>`;
        }
        case 'changePlace': {
            return `<b>${i18n.t('formatTitle.changePlace')}</b>`;
        }
        case 'changeSite': {
            return `<b>${i18n.t('formatTitle.changeSite')}</b>`;
        }
        case 'changePhoto': {
          return `<b>${i18n.t('formatTitle.changePhoto')}</b>`;
      }
        case 'changeBrand': {
            return `<b>${i18n.t('formatTitle.changeBrand')}</b>`;
        }
        case 'changeCompanies': {
            return `<b>${i18n.t('formatTitle.changeCompanies')}</b>`;
        }
        default: {
            return `<b>${i18n.t('formatTitle.default')}</b>`;
        }
    }
};

export const formatLabel = (props) => {
    switch(props.type) {
        case 'creation': {
            return `<b>${props.author.name}</b> ${i18n.t('formatLabel.creation')}`;
        }
        case 'changeStatus': {
            if(props.changeStatus.from) {
                return `<b>${props.author.name}</b> <b style="color: #585858">${i18n.t('formatLabel.changeStatusT')}</b> ${i18n.t('formatLabel.changeStatusT1')}`;
            } else {
                return `<b>${props.author.name}</b> <b style="color: green">${i18n.t('formatLabel.changeStatusF')}</b> ${i18n.t('formatLabel.changeStatusF1')}`;
            }
        }
        case 'changeMaintenanceStatus': {
            if(props.changeMaintenanceStatus.to === false) {
                return `${props.author.name} <b style="color: darkblue;">${i18n.t('formatLabel.changeMaintenanceStatusT')}</b> ${i18n.t('formatLabel.changeMaintenanceStatusT1')}`;
            } else {
                return `${props.author.name} <b style="color: #0363c3;">${i18n.t('formatLabel.changeMaintenanceStatusF')}</b> ${i18n.t('formatLabel.changeMaintenanceStatusF1')}`;
            }
        }
        case 'changePlace': {
            if (props.changePlace) {
                if(props.changePlace.from && props.changePlace.to) {
                    return `<b>${props.author.name}</b>${i18n.t('formatLabel.changePlace')}<b>${props.changePlace.from.name}</b>${i18n.t('formatLabel.changePlace1')}<b>${props.changePlace.to.name}</b>.`;
                } else if(props.changePlace.from && !props.changePlace.to) {
                    return `<b>${props.author.name}</b>${i18n.t('formatLabel.changePlace2')}<b>${props.changePlace.from.name}</b>${i18n.t('formatLabel.changePlace3')}`;
                } else if(!props.changePlace.from && props.changePlace.to) {
                    return `<b>${props.author.name}</b>${i18n.t('formatLabel.changePlace4')}<b>${props.changePlace.to.name}</b>.`;
                }
            }
            return '';
        }
        case 'changeSite': {
            if (props.changeSite) {
                if(props.changeSite.from && props.changeSite.to) {
                    return `<b>${props.author.name}</b>${i18n.t('formatLabel.changeSite')}<b>${props.changeSite.from.name}</b>${i18n.t('formatLabel.changeSite1')}<b>${props.changeSite.to.name}</b>.`;
                } else if(props.changeSite.from && !props.changeSite.to) {
                    return `<b>${props.author.name}</b>${i18n.t('formatLabel.changeSite2')}<b>${props.changeSite.from.name}</b>${i18n.t('formatLabel.changeSite3')}`;
                } else if(!props.changeSite.from && props.changeSite.to) {
                    return `<b>${props.author.name}</b>${i18n.t('formatLabel.changeSite4')}<b>${props.changeSite.to.name}</b>.`;
                }
            }
            return '';
        }
        case 'changePhoto': {
          if (props.changePhoto) {
            return `<b>${props.author.name}</b>${i18n.t('formatLabel.changePhoto')}`;
          }
          return '';
        }
        case 'changeEquipmentModel': {
            if(props.changeEquipmentModel.from && props.changeEquipmentModel.to) {
                return `<b>${props.author.name}</b>${i18n.t('formatLabel.changeEquipmentModel')}<b>${props.changeEquipmentModel.from.name}</b>${i18n.t('formatLabel.changeEquipmentModel1')}<b>${props.changeEquipmentModel.to.name}</b>.`;
            } else if(props.changeEquipmentModel.from && !props.changeEquipmentModel.to) {
                return `<b>${props.author.name}</b>${i18n.t('formatLabel.changeEquipmentModel2')}<b>${props.changeEquipmentModel.from.name}</b>.`;
            } else if(!props.changeEquipmentModel.from && props.changeEquipmentModel.to) {
                return `<b>${props.author.name}</b>${i18n.t('formatLabel.changeEquipmentModel3')}<b>${props.changeEquipmentModel.to.name}</b>.`;
            }
        }
        case 'changeCompany': {
            if(props.changeCompany.from && props.changeCompany.to) {
                return `<b>${props.author.name}</b>${i18n.t('formatLabel.changeCompany')}<b>${props.changeCompany.from.name}</b>${i18n.t('formatLabel.changeCompany1')}<b>${props.changeCompany.to.name}</b>.`;
            } else if(props.changeCompany.from && !props.changeCompany.to) {
                return `<b>${props.author.name}</b>${i18n.t('formatLabel.changeCompany2')}<b>${props.changeCompany.from.name}</b>${i18n.t('formatLabel.changeCompany3')}`;
            } else if(!props.changeCompany.from && props.changeCompany.to) {
                return `<b>${props.author.name}</b>${i18n.t('formatLabel.changeCompany4')}<b>${props.changeCompany.to.name}</b>.`;
            }
        }
        case 'changeReference': {
            return `<b>${props.author.name}</b>${i18n.t('formatLabel.changeReference')}${props.changeReference.from ? `${i18n.t('formatLabel.changeReference1')}<b>${props.changeReference.from}</b>`: '' }${i18n.t('formatLabel.changeReference2')}<b>${props.changeReference.to}</b>.`;
        }
        case 'changeSerialNumber': {
            return `<b>${props.author.name}</b>${i18n.t('formatLabel.changeSerialNumber')}${props.changeSerialNumber.from ? `${i18n.t('formatLabel.changeSerialNumber1')}<b>${props.changeSerialNumber.from}</b>`: ''}${i18n.t('formatLabel.changeSerialNumber2')}<b>${props.changeSerialNumber.to}</b>.`;
        }
        case 'changeDescription': {
          return `<b>${props.author.name}</b>${i18n.t('formatLabel.changeDescription')}${props.changeDescription.from ? `${i18n.t('formatLabel.changeDescription1')}<b>${props.changeDescription.from}</b>`: ''}${i18n.t('formatLabel.changeDescription2')}<b>${props.changeDescription.to}</b>.`;
      }
        case 'changeBrand': {
            if(props.changeBrand.from)
                return `<b>${props.author.name}</b>${i18n.t('formatLabel.changeBrand')}${props.changeBrand.from ? `${i18n.t('formatLabel.changeBrand1')}<b>${props.changeBrand.from}</b>` : ''}${i18n.t('formatLabel.changeBrand2')}<b>${props.changeBrand.to}</b>.`;
            return `<b>${props.author.name}</b>${i18n.t('formatLabel.changeBrand3')}<b>${props.changeBrand.to}</b>.`;
        }
        case 'changeCompanies':
            const addedOrRemovedCompanies = getArraysDifference(props.changeCompanies.from, props.changeCompanies.to);
            const isOneRemoved = addedOrRemovedCompanies.removed.length === 1;
            const isOneAdded = addedOrRemovedCompanies.added.length === 1;
            let timelineString = `<b>${props.author.name}</b> `;
            let andString = '';
            if (addedOrRemovedCompanies.removed.length > 0) {
                timelineString += ` ${isOneRemoved ? i18n.t('formatLabel.removedCompany'): i18n.t('formatLabel.removedCompanies')} <b>${formatNamesOnArray(addedOrRemovedCompanies.removed)}</b>`;
                andString = i18n.t('formatLabel.andString');
            }
            if (addedOrRemovedCompanies.added.length > 0) {
                timelineString += ` ${andString} ${isOneAdded ? i18n.t('formatLabel.addedCompany') : i18n.t('formatLabel.addedCompanies')} <b>${formatNamesOnArray(addedOrRemovedCompanies.added)}</b>`;
            }
            timelineString += '.';
            return timelineString;
        default: {
            return `${i18n.t('formatLabel.default')}`
        }
    }
};

/*module.exports = {
    borderColor,
    formatTitle,
    formatLabel,
};*/
